export { UserConsentDescription } from './user-consent-description';
